import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { settings } = useSettings();
  const business = settings?.business || {
    name: 'London Builders',
    address: 'Sakina, Raska Zone, Arusha, Tanzania',
    phone: '+255656472123',
    email: 'londonbuilderstz@gmail.com',
    whatsapp: '255656472123',
    workingHours: {
      weekdays: 'Mon-Fri: 8:30am - 5:30pm',
      saturday: 'Sat: 9:00am - 3:00pm',
      sunday: 'Closed'
    }
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <a href="#home" className="footer__logo">
              <img 
                src="/images/logo.png" 
                alt="London Builders" 
                className="footer__logo-img"
              />
            </a>
            <p className="footer__description">
              Your Vision, Our Expertise. We deliver excellence, innovation, and unwavering 
              commitment to quality. Your trusted construction partner in Tanzania.
            </p>
            <div className="footer__social">
              <a href="https://www.facebook.com/londonbuilderstz/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="London Builders on Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/london_builders_limited/" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="London Builders on Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="18" cy="6" r="1" fill="currentColor" stroke="none"/>
                </svg>
              </a>
              <a href={`https://wa.me/${business.whatsapp || '255656472123'}`} target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="London Builders on WhatsApp">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                  <path d="M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652a12.062 12.062 0 005.71 1.447h.005c6.585 0 11.946-5.336 11.949-11.896 0-3.176-1.24-6.165-3.495-8.411L20.52 3.449zM12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.975 1.005-3.638-.235-.374a9.86 9.86 0 01-1.51-5.26c.002-5.45 4.456-9.884 9.937-9.884 2.654 0 5.147 1.034 7.022 2.91a9.825 9.825 0 012.892 6.978c-.003 5.45-4.457 9.885-9.974 9.885z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div className="footer__links">
            <div className="footer__column">
              <h4 className="footer__column-title">Services</h4>
              <ul className="footer__list">
                <li><a href="#services">Residential Construction</a></li>
                <li><a href="#services">Commercial Projects</a></li>
                <li><a href="#services">Renovations & Extensions</a></li>
                <li><a href="#services">Interior Fit-Outs</a></li>
                <li><a href="#services">Project Management</a></li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4 className="footer__column-title">Company</h4>
              <ul className="footer__list">
                <li><a href="#about">About Us</a></li>
                <li><a href="#projects">Our Projects</a></li>
                <li><a href="#about">Our Team</a></li>
                <li><a href="#contact">Testimonials</a></li>
                <li><a href="#contact">Careers</a></li>
              </ul>
            </div>
            
            <div className="footer__column">
              <h4 className="footer__column-title">Contact</h4>
              <ul className="footer__list footer__list--contact">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                  {business.address}
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
                  </svg>
                  <a href={`tel:${business.phone}`}>{business.phone}</a>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <a href={`mailto:${business.email}`}>{business.email}</a>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  <span>
                    {business.workingHours?.weekdays}<br/>
                    {business.workingHours?.saturday}
                    {business.workingHours?.sunday ? <><br/>{business.workingHours?.sunday}</> : null}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer__bottom">
          <div className="footer__credits">
            <p className="footer__copyright">
              © {currentYear} {business.name || 'London Builders'}. All rights reserved.
            </p>
            <p className="footer__powered-by">Powered by QuestMind</p>
          </div>
          <div className="footer__legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <button
              type="button"
              className="footer__legal-btn"
              onClick={() => window.dispatchEvent(new CustomEvent('lb:open-cookie-settings'))}
            >
              Cookie Settings
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
